import { useConfigContext } from '../../../contexts/ConfigContext/ConfigContextProvider'
import './ForumCardFooter.css'

export default function ForumCardFooter({report}) {
   
   const { jsonTexts } = useConfigContext()
   const texts = jsonTexts?.foro
   return (
      <div className='ForoCardFooter-container'>
         <a className='ForoCardFooter--link' onClick={report} >{texts?.reportButtonText}</a>
      </div>
   )
}
